import React, {useRef, useCallback} from 'react'
import { NavBarHome } from '../../components/ui/NavBarHome';
import { useNavigate, NavLink } from 'react-router-dom';
import  ListCourses  from '../../controllers/ListCourses';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import {encode as base64_encode} from 'base-64';
import { FooterHome } from '../footer/FooterHome';

// Home to display "Cursos"
export const HomeScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const path = 'course/list'
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect')){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    
    const { loading, error, list, hasMore } = ListCourses(path,user.languaje, token);
    const loader = useRef(null);
    const observer = useRef()
    const handleObserver = useCallback((node) => {
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                
            }
        })
        if (node) observer.current.observe(node)
    }, [hasMore]);
    let imgBackType = '';
    let imgBack = '';
    if(window.localStorage.getItem('edufami_background_courses')){
        imgBackType = JSON.parse(window.localStorage.getItem('edufami_background_courses')).image_type
        imgBack = JSON.parse(window.localStorage.getItem('edufami_background_courses')).image_value
    }
    else{
        dispatch(logout(token));
        history( '/auth/login', {
            replace: true
            });
    }
    
    if(error){
        dispatch(logout(token));
        history( '/auth/login', {
            replace: true
          });
    }
   

    const disCourse = ()=>{
        let lists = list;
        if(list.status === "Token is Expired" ){
            dispatch(logout(token));
            history( '/auth/login', {
                replace: true
                });  
        }
        return lists.map((course) => (

            <div ref={handleObserver} key={course.id} className="course-containter-img">
                <NavLink to={ `/course/${ course.id }` } className="wfp--link">
                    <div className="couser-content-container">
                        {
                            (course.background_button_type==="svg")
                            ?
                            <img className="img-course" src = {`data:image/svg+xml;base64,${base64_encode(course.background_button)}`} alt={course.name_course}/>
                            :
                            (course.background_button_type!==null)?
                            
                            <img className="img-course" src = {`data:image/${course.background_button_type}+xml;base64,${btoa(course.background_button)}`} alt={course.name_course}/>
                            :
                            <img className="img-course" src = {course.background_button} alt={course.name_course}/>
                        }

                        <div className="tit-back-course">
                            <span className="span-tit-back-course">{course.name}</span>
                        </div>
                    </div>
                </NavLink>
            </div>
     
        ));
        
    }
    
    return (
            <div className="fund-main-enter">
                {
                    imgBackType && (imgBackType==="svg")
                    ?
                    <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                    :
                    <img className="fund-start-b-img" src = {`data:image/${imgBackType}+xml;base64,${btoa(imgBack)}`} alt="Back Ground"/>
                } 
                <NavBarHome />
                <div className="content-courses" >
                {loading && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>} 
                {list && disCourse() }
                </div>

                {error && <p>Error!</p>}
                <div ref={loader} />
                <FooterHome />
            </div>
    )
}

